import { useCallback, useState } from 'react';
import { useAppContext } from 'src/contexts/AppContext';
import { useClientLogContext } from 'src/contexts/ClientLogContext';
import { Content } from 'src/contexts/ContentContext';
import { PosDropdownItem } from 'src/core/POS/PosDropdown';
import { RotatingWrapper } from 'src/core/ui/AnimatingWrapper';
import { ProcessingIcon } from 'src/svgs/Viagogo';
import { ContentId } from 'src/utils/constants/contentId';
import { downloadFileFromBlob } from 'src/utils/fileUtils';
import { tryInvokeApi } from 'src/utils/tryExecuteUtils';
import { MarketplacePaymentClient } from 'src/WebApiController';

export const ExportPaymentLinesAction = ({
  marketplacePaymentId,
}: {
  marketplacePaymentId: number;
}) => {
  const { activeAccountWebClientConfig } = useAppContext();
  const { showErrorDialog } = useClientLogContext();
  const [isLoading, setIsLoading] = useState(false);

  const onExportButtonClicked = useCallback(async () => {
    setIsLoading(true);

    await tryInvokeApi(
      async () => {
        const result = await new MarketplacePaymentClient(
          activeAccountWebClientConfig
        ).exportPaymentLines(marketplacePaymentId);

        if (result.data) {
          downloadFileFromBlob(
            result.fileName ?? 'paymentlines.csv',
            result.data
          );
        }
      },
      (error) => {
        showErrorDialog('MarketplacePaymentClient.exportPaymentLines', error, {
          trackErrorData: { marketplacePaymentId },
        });
      },
      () => setIsLoading(false)
    );
  }, [activeAccountWebClientConfig, marketplacePaymentId, showErrorDialog]);

  return (
    <PosDropdownItem
      keepOpenAfterSelection
      onClick={(e) => {
        e.stopPropagation();
        onExportButtonClicked();
      }}
    >
      {isLoading && (
        <RotatingWrapper>
          <ProcessingIcon />
        </RotatingWrapper>
      )}
      <Content id={ContentId.DownloadLines} />
    </PosDropdownItem>
  );
};
